import React, { useState } from "react";
import { Card, Col, Container, Form, Row, Spinner } from "react-bootstrap";
import { Link, useNavigate } from "react-router-dom";
import styles from "./DashboardProductList.module.css";
import { connect } from "react-redux";
import { BsFileEarmarkPlus, BsTrash } from "react-icons/bs";
import { AiOutlineEdit } from "react-icons/ai";
import { useModals } from "@mantine/modals";
import { Text } from "@mantine/core";
import { toast } from "react-toastify";
import { Modal, TextInput, Textarea } from "@mantine/core";
import { BASE_URL } from "../../constant/URL";
import { deleteProduct } from "../../actions/Book.action";

const DashboardProductList = ({ product, deleteProduct }) => {
  const [list, setList] = useState(product === null ? [] : product);
  const modals = useModals();
  const [modalOpened, setModalOpened] = useState(false);
  const [singleProductDetail, setSingleProductDetail] = useState({});
  const navigate = useNavigate();

  const [searchText, setSearchText] = useState("");

  const searchHandeler = (text) => {
    if (text !== "") {
      setList(
        product.filter((item) => {
          return item.name.toLowerCase().includes(text.toLowerCase());
        })
      );
    } else {
      setList(product);
    }
    setSearchText(text);
  };

  // DELETE HANDELER
  const deleteHandeler = (id) =>
    modals.openConfirmModal({
      title: "Delete this Product",
      centered: true,
      children: (
        <Text size="md">
          Are you sure you want to delete this Product? This action is
          destructive and you can not undo it.
        </Text>
      ),
      labels: { confirm: "Delete Product", cancel: "No don't delete it" },
      confirmProps: { color: "red" },
      onCancel: () => {},
      onConfirm: () => confirmHandeler(id),
    });

  // On CONFIRM DELETE
  const confirmHandeler = async (id) => {
    let check = await deleteProduct(id);
    if (check === true) {
      toast.success("Product deleted successfully");
      navigate("/dashboard");
    } else {
      toast.error("Something went wrong");
    }
  };

  // MODAL HANDELER
  const handleModal = (productDetail) => {
    setSingleProductDetail(productDetail);
    setModalOpened(true);
  };

  return (
    <Container className="py-4">
      <Modal
        centered
        size="lg"
        opened={modalOpened}
        onClose={() => setModalOpened(false)}
        title={<b>Order detail!</b>}
      >
        <>
          <TextInput
            className="mt-2"
            label="Name"
            placeholder="Name"
            value={singleProductDetail.name}
          />
          <TextInput
            className="mt-2"
            label="Contact Email"
            placeholder="Email"
            value={singleProductDetail.email}
          />
          <TextInput
            className="mt-2"
            label="Company Name"
            placeholder="Company"
            value={singleProductDetail.company}
          />
          <TextInput
            className="mt-2"
            label="Project"
            placeholder="Project Name"
            value={singleProductDetail.project}
          />
          <TextInput
            className="mt-2 fw-bold"
            label="Contact Number"
            placeholder="Contact Number"
            value={singleProductDetail.contactNumber}
          />
          <Textarea
            autosize
            minRows={1}
            maxRows={2}
            className="mt-2"
            label="Delivery Address"
            placeholder="Delivery Address"
            value={singleProductDetail.deliveryAddress}
          />
          <TextInput
            className="mt-2"
            label="Delivery Date"
            placeholder="Delivery Date"
            value={singleProductDetail.deliveryDate}
          />
          <TextInput
            className="mt-2"
            label="Service Needed"
            placeholder="Service Needed"
            value={singleProductDetail.service}
          />
        </>
      </Modal>

      <div className="d-flex justify-content-between align-items-center pb-3 ">
        <div className="d-flex align-items-center w-100">
          <span className="d-block fs-4">Search Product</span>
          <Form.Control
            type="text"
            placeholder="Search product by name..."
            className={`${styles.searchInput}`}
            onChange={(e) => searchHandeler(e.target.value)}
            value={searchText}
          />
        </div>
        <div className="">
          <Link to="/dashboard/product/add" className={styles.add}>
            <BsFileEarmarkPlus />
          </Link>
        </div>
      </div>
      <Card className="crd p-md-4 pb-md-0 p-2">
        <Card.Body>
          {product === null ? (
            <div
              className="d-flex justify-content-center align-items-center"
              style={{ minHeight: 600 }}
            >
              <Spinner variant="dark" animation="grow" />
            </div>
          ) : (
            <>
              {list && list.length === 0 && (
                <span className="d-block text-center fs-4 lead pb-4">
                  No product Found
                </span>
              )}
              {list &&
                list.map((productItem, i) => (
                  <Row
                    key={productItem._id}
                    className={`mb-3 pb-3 ${
                      list.length - 1 === i ? "" : "border-bottom"
                    }`}
                  >
                    <Col md={2}>
                      <Row>
                        <Col
                          md={9}
                          className={`${styles.small} d-flex align-items-center border `}
                        >
                          <div className={styles.img_wrapper}>
                            <img
                              crossOrigin="true"
                              src={`${BASE_URL}/image/${productItem.primaryImage}`}
                              alt={productItem.name}
                              className={styles.img}
                            />
                          </div>
                        </Col>
                        <Col
                          md={2}
                          className="d-flex justify-content-center align-items-center "
                        >
                          <div className={styles.line}></div>
                        </Col>
                      </Row>
                    </Col>
                    <Col md={9} className="">
                      <div
                        className="d-flex align-items-center h-100 justify-content-start"
                        onClick={() => navigate(`/details/${productItem._id}`)}
                      >
                        <span className={` fw-bold ${styles.link}`}>
                          {productItem.name}
                        </span>
                      </div>
                    </Col>

                    <Col
                      md={1}
                      className="d-flex justify-content-center align-items-center"
                    >
                      <Link
                        to={`/dashboard/product/${productItem._id}`}
                        className={` fw-bold fs-4 ${styles.link}`}
                      >
                        <AiOutlineEdit />
                      </Link>
                      <span
                        className={`ms-3 fw-bold fs-4 ${styles.link}`}
                        onClick={() => deleteHandeler(productItem._id)}
                      >
                        <BsTrash className="text-danger" />
                      </span>
                    </Col>
                  </Row>
                ))}
            </>
          )}
        </Card.Body>
      </Card>
    </Container>
  );
};

export default connect(null, { deleteProduct })(DashboardProductList);
